'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.filter('percentage', function() {
  return function(text) {
    var result = String(text);
    // if percentage has trailing zeros after the decimal place remove them
    var regex = /(\.|,).*0+$/;
    if (result.match(regex)) {
      regex = /0+$/;
      result = result.replace(regex, '');
    }
    // if resulting percentage has no remaining digits after the decimal, remove the decimal
    regex = /(\.|,)$/;
    return result.replace(regex, '');
  };
});
